import script from "./MonarchCategoriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MonarchCategoriesView.vue?vue&type=script&setup=true&lang=js"

import "./MonarchCategoriesView.vue?vue&type=style&index=0&id=57b3c88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b3c88e"]])

export default __exports__